import {onDocumentReady} from '../utils/events';
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

onDocumentReady(() => {
    const sliderEl = document.querySelector('.content-w-slider__slider');

    if (sliderEl) {
        const splide = new Splide(sliderEl, {
            type: 'slide',
            rewind: false,
            direction: 'ltr',
            perPage: 4,
            perMove: 1,
            arrows: true,
            keyboard: 'global',
            pagination: false,
            drag: true,
            gap: 24,
            focus: 0,
            omitEnd: true,
            breakpoints: {
                1440: {
                    perPage: 3,
                },
                1023: {
                    perPage: 2,
                    gap: 20,
                },
                640: {
                    perPage: 1,
                    gap: 20,
                },
            },
        });

        splide.mount();
    }
});
